import BulkUploadDriverSecondaryLocalityManager from "../../../views/BulkUploadDriverSecondaryLocalityMapping";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadDriverSecondaryLocalityManagerRoutes = [
  {
    menuName: MenuNames.BULK_UPLOAD_DRIVER_SECONDARY_LOCALITY_MAPPING,
    path: "/bulk-upload-driver-secondary-locality-mapping",
    component: BulkUploadDriverSecondaryLocalityManager,
    exact: true,
  },
];

export default BulkUploadDriverSecondaryLocalityManagerRoutes;